import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { Dialog, DialogProps } from "../core/components/dialog";
import { FieldInstance } from "../core/components/field";
import { TextBox } from "../core/components/textBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { CRQuestionContext, CRQuestionEntity } from "./crQuestion"
import React from "react"
export default class CRTagsGrid extends React.Component<CRTagsGridProps, CRTagsGridState> {
    private _factory = ComponentHelper.createFactory();
    private _gridOptions: any;
    private _enabled: boolean;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._updateGridData();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.state = { dialogOpen: false, gridData: null, currentItem: null, translations: props.context.translations }
        this._setEvents();
    }

    private _changeGridStatus = (status: boolean) => {
        this._enabled = status;
        this.setState({});
    }

    private _afterGridDataChange = () => {
        MetaDataHelper.setFieldValue(this.props.entity, "entity.Tags", this.state.gridData);
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.trigger(SheetEventType.Custom, { command: "gridDataChanged" });
    }

    private _updateGridData = () => {
        let gridData = this.state.gridData.slice(0);
        let item = this.state.currentItem;

        if (gridData.filter(f => (f.Value === item.Value) && (f.Key !== item.Key)).length === 0) {
            let pos = this._getPos();
            if (pos < 0) {
                gridData.push(item);
            } else {
                gridData[pos] = item;
            }
            this.setState({ gridData: gridData }, () => { this._afterGridDataChange() });
        } else {
            NotificationHelper.showWarningMessage(this.state.translations["WebSMS.Report.Question.Messages.UniqueTags"]);
        }
    }

    private _getPos = () => {
        let gridData = this.state.gridData.slice(0);
        let item = this.state.currentItem;
        let pos = -1;
        for (let i = 0; i < gridData.length; i++) {
            if (gridData[i].Key === item.Key) {
                pos = i;
                break;
            }
        }
        return pos;
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createTextBox()}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private _createTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.currentItem.Value, "");
        props.onChange = (field: { model: string }, value: any, dataItem?: { Tag: string }) => {

            let item = this.state.currentItem;
            item.Value = value;
            this.setState({ currentItem: item });
        };
        return (
            <FieldInstance label={this.state.translations["WebSMS.Report.Question.Tag"]} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _openDialog = (dataItem: Tag = null) => {
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                Key: this._getKey(),
                Value: ""
            };
        }
        this.setState({ currentItem: dataItem, dialogOpen: true });
    }

    private _getKey = () => {
        const griData = this.state.gridData;
        let key: number = 0;
        for (let i = 0; i < griData.length; i++) {
            if (griData[i].Key > key)
                key = griData[i].Key;
        }
        return key + 1;
    }

    private _delete = (dataItem: Tag) => {
        DialogHelper.confirm(this.state.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let gridData = this.state.gridData.filter(f => f.Key !== dataItem.Key);
                this.setState({ gridData: gridData }, () => { this._afterGridDataChange() });
            }
        });
    }

    private _createGrid = () => {
        let fullLoaded: boolean = Helper.hasValue(this.state.gridData) && Helper.hasValue(this._gridOptions) && Helper.hasValue(this.state.translations);
        if (fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: this._enabled });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: this._enabled });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this._enabled });

            let grid = (
                <Grid data={this.state.gridData}
                    options={this._gridOptions}
                    id="customReportTagsGrid"
                    standardButtons={standardButtons}
                    onClickStandardButton={this._handleClickStandardButton}
                />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Tag) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this._openDialog(dataItem);
                break;
            case ToolBarStandardButtonType.NEW:
                this._openDialog();
                break;
            case ToolBarStandardButtonType.DELETE:
                this._delete(dataItem);
                break;
        }
    }

    private _setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "entityStatusChanged") {
                this._changeGridStatus(cus.value);
            }
        });
    }

    getTagsGridOptions = (translations: ComponentTranslations) => {
        if (this.props.context.tagsGridOptions) {
            return this.props.context.tagsGridOptions;
        }

        return {
            "sortable": true,
            "pageable": false,
            "groupable": false,
            "filterable": true,
            "selectable": true,
            "resizable": true,
            "scrollable": true,
            "columns": [
                {
                    "field": "Value",
                    "title": translations["WebSMS.Report.Question.Tags"],
                    "width": 80
                }
            ]
        };
    }

    getTranslations = async (): Promise<ComponentTranslations> => {
        if (this.state.translations) {
            return this.state.translations;
        }
        const result = await (await Helper.getTranslations(["WebSMS.Report.Question.Messages.UniqueTags", "Standard.Msg.Loeschen", "WebSMS.Report.Question.Tag", "WebSMS.Report.Question.Tags"])).Data as any;
        return result;
    }

    async componentDidMount() {
        const translations = await this.getTranslations();
        this._gridOptions = this.getTagsGridOptions(translations as ComponentTranslations);
        this._enabled = !this.props.disabled;
        this.setState({ gridData: this.props.value, translations: translations });
    }

    render() {
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};

interface CRTagsGridProps extends React.PropsWithChildren {
    context: CRQuestionContext;
    entity: CRQuestionEntity;
    value: Tag[];
    disabled: boolean;
}

interface CRTagsGridState {
    dialogOpen: boolean;
    gridData: Tag[];
    currentItem: Tag;
    translations: ComponentTranslations;
}

interface ComponentTranslations {
    "WebSMS.Report.Question.Messages.UniqueTags": string,
    "Standard.Msg.Loeschen": string,
    "WebSMS.Report.Question.Tag": string,
    "WebSMS.Report.Question.Tags": string
}

interface Tag {
    Key: number;
    Value: string;
}